import { useSelector } from 'react-redux';
import { coloEnabledSelector, miningEnabledSelector } from 'store/slices/features-slice';

// Guard hook (Plan 06 §Key contracts): miningEnabled defaults to visible (not-yet-loaded/true
// both read as visible; only an explicit `mining:false` hides mining surfaces). coloEnabled only
// renders once the org's flags have explicitly resolved to `colo:true`.
export const useFeatures = () => {
  const miningEnabled = useSelector(miningEnabledSelector);
  const coloEnabled = useSelector(coloEnabledSelector);

  return { miningEnabled, coloEnabled };
};

export default useFeatures;
